export default {
  title: "Egram Panchayat",
  data: [
    {
      layout: "SuggestionsPage",
      title: "અભિપ્રાય",
      description: "તમારો અભિપ્રાય આપવા માટે આભાર ",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15553.319056429109!2d77.57462069545443!3d12.950738147237534!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x222ebff8a6f5fbea!2sJust%20Signs%20India%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1597755249741!5m2!1sen!2sin",

      data: [],
      inputs: {
        gramname: {
          label: "ગ્રામ પંચાયત નું નામ ",
          placeholder: "ગ્રામ પંચાયત નું નામ ",
        },
        talukaname: {
          label: "તાલુકા નું નામ ",
          placeholder: "તાલુકા નું નામ ",
        },
        districtname: {
          label: "જિલ્લા નું નામ ",
          placeholder: "જિલ્લા નું નામ ",
        },
        anyname: {
          label: "સરપંચ/તલાટી/કો.ઓપરેટર નું નામ  ",
          placeholder: "સરપંચ/તલાટી/કો.ઓપરેટર નું નામ  ",
        },

        mobile: {
          label: "મોબાઈલ નંબર ",
          placeholder: "મોબાઈલ નંબર ",
        },
        email: {
          label: "ઇમેઇલ   ",
          placeholder: "ઇમેઇલ  ",
        },
        otp: {
          label: "Otp",
          placeholder: "otp  ",
        },
      },
      btnTitle: "સબમિટ ",
      successMsg: `
      અમારો સંપર્ક કરવા બદલ આભાર. અમારા સહયોગીઓ ટૂંક સમયમાં તમારો સંપર્ક કરશે.`,
    },
  ],
};
